import { useEffect, useCallback } from 'react';
import { IFRAME_ACTIONS, API_TIMEOUT_MS } from '../constants';

export const useIframeMessaging = (iframeRef, messageHandlers) => {
  
  const sendMessageToIframe = useCallback((action, payload = null) => {
    const iframe = iframeRef.current;
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage({
        action,
        payload
      }, window.location.origin);
    }
  }, [iframeRef]);

  const getAccountDataFromIframe = useCallback(async () => {
    const iframe = iframeRef.current;
    if (!iframe || !iframe.contentWindow) {
      throw new Error('Таблица не загружена.');
    }

    return new Promise((resolve, reject) => {
      const timeout = setTimeout(() => {
        reject(new Error('Timeout waiting for account data'));
      }, API_TIMEOUT_MS);

      const handleResponse = (event) => {
        if (event.data.action === IFRAME_ACTIONS.ACCOUNT_DATA_RESPONSE) {
          clearTimeout(timeout);
          window.removeEventListener('message', handleResponse);
          resolve(event.data.payload.account);
        }
      };

      window.addEventListener('message', handleResponse);
      iframe.contentWindow.postMessage({ 
        action: IFRAME_ACTIONS.GET_ACCOUNT_DATA 
      }, window.location.origin);
    });
  }, [iframeRef]);

  const displayDataInIframe = useCallback((account, dates, searchTerm = '') => {
    sendMessageToIframe(IFRAME_ACTIONS.DISPLAY_DATA, { 
      account, 
      dates, 
      searchTerm 
    });
  }, [sendMessageToIframe]);

  const searchInIframe = useCallback((searchTerm) => {
    sendMessageToIframe(IFRAME_ACTIONS.SEARCH_COUNTERPARTIES, { 
      searchTerm 
    });
  }, [sendMessageToIframe]);

  // Обработчик сообщений от iframe
  useEffect(() => {
    const handleMessage = (event) => {
      const { action, payload } = event.data;
      
      if (messageHandlers[action]) {
        messageHandlers[action](payload);
      } else {
        console.log('Unhandled message from iframe:', action, payload);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [messageHandlers]);

  return {
    sendMessageToIframe,
    getAccountDataFromIframe,
    displayDataInIframe,
    searchInIframe
  };
};